import { groupBy, orderBy } from 'lodash';

export const usePostExtractor = () => {
  const extractPostIdGroupByPart = (data) => {
    const postIdGroupByPart = {};

    const postGroupByPart = groupBy(data, 'part');

    for (const part in postGroupByPart) {
      if (Object.hasOwnProperty.call(postGroupByPart, part)) {
        const postsInPart = orderBy(postGroupByPart[part], ['order'], ['asc']);

        postIdGroupByPart[part] = postsInPart.map(({ id }) => id);
      }
    }

    return postIdGroupByPart;
  };
  return {
    extractPostIdGroupByPart
  };
};
